module.exports = __webpack_public_path__ + "static/media/ajax-Loader.45798e6e.gif";